import { deleteBundle } from "../../api/inventoryService";

export const useDeleteBundle = (successCallback) => {
    const remove = async (id) => {
        try {
            await deleteBundle(id);
            successCallback();
        } catch (error) {
            console.error("Failed to delete bundle:", error);
            throw error;
        }
    };

    return { remove };
};